<template>
    <el-dialog
            class="dialog"
            :visible.sync="showModel"
            :modal="isModal"
            :show-close="false"
            :close-on-click-modal="isCloseOnClickModal"
            :close-on-press-escape="false"
            :modalAppendToBody="false"
            :append-to-body="appendToBody"
            custom-class="commDialog">

        <!-- 右上角關閉按鈕，當 isCancel == true 並且 negativeLabel爲空白才會出現 -->
        <el-row type="flex" justify="space-between" v-if="isShowClose">
            <slot name="left">
                <el-col :span="7"/>
            </slot>
            <slot name="center">
                <el-col :span="10"/>
            </slot>
            <slot name="right">
                <el-col :span="7">
                    <!--todo 關閉-->
                    <el-button class="close" @click="cancel"/>
                </el-col>
            </slot>
        </el-row>
        <el-row type="flex" justify="space-between" v-else />

        <div class="container" id="commDialogContainer">
            <img v-show="isIcon" :src="icon" class="icon">
            <vue-qrcode v-if="isQrcode" v-model="qrcodeSrc" style="width: 200px; height: 200px" />
            <div slot="title" class="outer-content" v-html="outerContent"/>
            <h2 class="mt-2 yellow" v-if="isShowTime"><i class="el-icon-time mr-1"/>{{exchangeTime}}</h2>
            <div v-show="mainContent!==''" class="main-content" v-html="mainContent"/>
            <el-form v-if="isTextBox" :model="text" class="mt-2 w-100 max-w-260">
                <el-form-item :label=textTitle class="mb-0">
                    <el-input v-model="text.content" :type=textType :maxlength="textMaxlength"/>
                </el-form-item>
            </el-form>
            <slot></slot>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel" round v-show="isCancel && negativeLabel!=='' " type="info">{{negativeLabel}}</el-button>
                <el-button @click="confirm" round v-show="isConfirm" type="primary">{{positiveLabel}}</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    import VueQrcode from "vue-qrcode";

    export default {
        name: "CommDialog",
        components: {
          VueQrcode,
        },
        props: {
            icon: {default: require('@/assets/images/dialog_question.svg')},
            outerContent: {default: "提醒"},
            mainContent: {default: ''},
            positiveLabel: {default: "確定"},
            negativeLabel: {default: "取消"},
            value: {required: false, type: Boolean, default: false},        //是否顯示 dialog (dialog開關)?
            eventType: {required: false, type: Number, default: 0},            //事件種類辨認用，會在 result 中回傳，可以在顯示 dialog前設定好，在 result中以此來辨認目前是哪個事件的 result
            isCancel: {default: true},
            isModal: {default: true},
            isConfirm: {default: true},
            isShowClose: {default: false},
            isIcon: {default: true},
            isQrcode: {default: false},
            qrcodeSrc: {default: 1},
            isCloseOnClickModal: {default: false},
            appendToBody:{default: false},
            isTextBox: {default: false},
            textType: {default: 'tel'},
            textMaxlength: {default: '12'},
            textTitle: {default: ''},
            isClearText: {default: false},
            isShowTime: {default: false},
            defaultTextContent: {default: ''},
        },
        data() {
            return {
                showModel: this.value,
                text: { content: '' },
                //掃碼兌換的時間
                exchangeTime: '',
            }
        },
        created() {

        },
        mounted() {
            //如果右上 close 顯示了，isCancel 就不顯示
            if (this.isShowClose) {
                this.isCancel = false;
            }

            if (this.defaultTextContent !== "") {
                this.text.content = this.defaultTextContent
            }
        },
        watch: {
            value: function () {
                this.showModel = this.value;

                if(this.isClearText) {
                  this.text.content = '';
                }
            },
            isShowTime(){
                this.getCurrentTime()
            },
        },
        methods: {
            cancel() {
                this.showModel = false;
                //回傳 result，外部接收到 result事件後再做處理
                // args1 : 是否確定？
                // args2 : 事件類型
                this.$emit('result', false, this.eventType);
            },
            confirm() {
                if (!this.isTextBox) {
                    this.showModel = false;
                }
                //回傳 result，外部接收到 result事件後再做處理
                this.$emit('result', true, this.eventType, this.text.content);
            },
            getCurrentTime() {
                //兌換成功的時間抓取現在時間
                let hh = new Date().getHours();
                let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
                this.exchangeTime = hh+':'+mf;
            }
        }
    }
</script>

